<template>
  <section>
    <h2 class="heading-1">
      {{ i18n(translations.section1Title) }}
    </h2>
    <p class="text-static-default-low body-1 pt-8">
      {{ i18n(translations.section1Description) }}
    </p>

    <ComparisonArea
      :brand
      :category-id
      class="pt-32 text-center"
      variant="standard_vs_new"
    />

    <p class="body-2 my-32">
      {{ i18n(translations.section1Note) }}
    </p>
    <!-- TODO: PPI-7924 - Temporarily disabled until we have a link for laptops -->
    <!-- <p v-if="link" class="body-2-bold my-32 text-center">
      <RevLink target="_blank" :to="link">
        {{ i18n(translations.section1Link) }}
      </RevLink>
    </p> -->
  </section>
  <RevDivider />
  <section class="mt-20">
    <h3 class="heading-3 py-24">
      {{ i18n(translations.section2Title) }}
    </h3>
    <BatteryFaq class="-mx-24" />
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDivider } from '@ds/components/Divider'

import translations from '../../NewBatteryModal.translations'
import BatteryFaq from '../BatteryFaq/BatteryFaq.vue'
import ComparisonArea from '../ComparisonArea/ComparisonArea.vue'

defineProps<{
  brand: string
  categoryId: string
}>()

const i18n = useI18n()
</script>
